export default __webpack_public_path__ + "static/media/meal.b3fb45b5.jpg";